// Angular
import { computed, Injectable, signal } from '@angular/core';

// App constants
import {
  getRegistrationStepRoutes,
  RegistrationStepRoute,
} from '@app/features/registration/constants/registration-steps.const';

@Injectable({ providedIn: 'root' })
export class RegistrationWizardService {
  readonly isLegalEntity = signal(false);

  readonly stepRoutes = computed(() => getRegistrationStepRoutes(this.isLegalEntity()));

  setIsLegalEntity(value: boolean): void {
    this.isLegalEntity.set(value);
  }

  isValidStepRoute(route: RegistrationStepRoute): boolean {
    return this.stepRoutes().includes(route);
  }
}
